
import detectBrowserLanguage from 'detect-browser-language'

export default function Translate(es, en) {

    const lang = String(detectBrowserLanguage());
    if (lang.includes("es")) return es;
    else return en;
}